const productSituation = Object.freeze({
  ATIVO: 'ATIVO',
  GANHO: 'GANHO',
  PERDIDO: 'PERDIDO',
  LIQUIDADO: 'LIQUIDADO'
})

export default productSituation



// WEBPACK FOOTER //
// ./src/enums/enumProductSituation.js